import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleFieldConfig } from '../simple-field.interface';

@Component({
  selector: "app-button",
  template: `
<div fxFlex="100" [formGroup]="group">
<button type="submit" mat-raised-button class="primary">{{field.label}}</button>
</div>
`,
  styles: []
})
export class ButtonComponent implements OnInit {
  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
